import { useEffect } from 'react';

export const getSessionId = () => {
    if (typeof window === 'undefined') return undefined;
    let sessionId = sessionStorage.getItem('analytics_session_id');
    if (!sessionId) {
        sessionId = typeof crypto !== 'undefined' && crypto.randomUUID 
            ? crypto.randomUUID() 
            : Math.random().toString(36).substring(2) + Date.now().toString(36);
        sessionStorage.setItem('analytics_session_id', sessionId);
    }
    return sessionId;
};

export const trackEvent = (eventName: string, data: Record<string, any> = {}) => {
    try {
        const payload = {
            event_name: eventName,
            session_id: getSessionId(),
            page: typeof window !== 'undefined' ? window.location.pathname : undefined,
            tool: data.tool,
            country: undefined, 
            device: typeof window !== 'undefined' ? (window.innerWidth < 768 ? 'mobile' : 'desktop') : undefined,
            browser: undefined, 
            traffic_source: typeof document !== 'undefined' ? document.referrer : undefined,
            metadata_json: data.metadata || {},
        };

        const backendUrl = process.env.NEXT_PUBLIC_BACKEND_URL || 'http://localhost:8000';
        fetch(`${backendUrl}/api/analytics/event`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
            keepalive: true
        }).catch(e => { /* silent fail */ });
    } catch (e) {
        // silent fail
    }
};

export const useAnalytics = (toolName: string) => {
    useEffect(() => {
        trackEvent('page_view', { tool: toolName });
    }, [toolName]);
};
